module.exports = __webpack_public_path__ + "static/img/banner3.d2ae9e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/videoDetail/banner3.png
// module id = N0Ax
// module chunks = 17